export const getKeyToggledArray = <T>(arr: T[], key: T): T[] => {
  if (arr.includes(key)) {
    return arr.filter((val) => val !== key);
  }
  return [...arr, key];
};
